import React from 'react';

import { DefaultLoader } from './default-loader';

import GravityLoader from '../../../assets/media/loader/gravity-loader.png';

import './monitor-loader.scss';

interface MonitorLoaderProps {
  disableLoader: boolean;
}

export const MonitorLoader: React.FC<MonitorLoaderProps> = ({
  disableLoader
}) => {

  if (!disableLoader) return <DefaultLoader />;

  return (
    <div className="gravity-loader-wrapper" id="loader">
      <div className="gravity-loader-container">
        <img
          alt="Loading..."
          src={GravityLoader}
          className="gravity-loading-icon"
        />
      </div>
    </div>
  );
};
